module.exports = __webpack_public_path__ + "img/4.046eeb4.png";